import { LecternIcon } from './LecternIcon';

/**
 * author: Michael Irigoyen
 * id 8EBB4944-6CD1-40E3-A5B7-6962BD23C0E6
 * name lectern
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lectern.svg
 * tags
 */
export const LecturnIcon = LecternIcon;
export default LecturnIcon